import { createIcon } from '@/components/atoms/Icon';

export default createIcon({
  title: 'Social event',
  displayName: 'SocialEventIcon',
  viewBox: '0 0 20 20',
  path: 'M9.001 4.33a.75.75 0 0 1-.493.939c-1.123.349-1.631 1.274-1.76 2.194a.75.75 0 0 1-1.486-.21c.183-1.296.956-2.842 2.8-3.416a.75.75 0 0 1 .94.494ZM11.761 17.328c3.471-.718 6.572-4.007 6.572-8.845 0-3.997-2.5-7.994-8-7.994s-8 3.997-8 7.494c0 5.265 3.085 8.604 6.545 9.339l-1.62 1.937a.749.749 0 0 0 .575 1.23h5a.75.75 0 0 0 .57-1.236l-1.642-1.925Zm-1.428-1.351c3.114 0 6.5-2.768 6.5-7.494 0-1.703-.534-3.33-1.567-4.51-1.004-1.146-2.58-1.985-4.934-1.985-2.355 0-3.944.841-4.954 1.947C4.34 5.07 3.833 6.573 3.833 7.983c0 5.283 3.439 7.994 6.5 7.994Z',
});
